/*
 * @Description: Do not edit
 * @Author: 文件创建人：任亮
 * @Date: 2025-08-08 13:47:07
 * @LastEditors: 文件最后更新人：任亮
 * @LastEditTime: 2026-02-09 19:01:25
 */
import layout from "@/components/layout/index.vue";
import useStore from "@/config/pinia";

const routers: Object[] = [
  {
    path: "/",
    name: "index",
    redirect: "redirectPath",
    component: layout,
    children: [
      {
        path: "/permissions",
        name: "permissions",
        meta: {
          menu: "permissions",
          bread: [
            {
              label: "无权限",
              name: "permissions",
            },
          ],
        },
        component: () => import("@/views/permissions/permissions.vue"),
      },
      {
        path: "/overivew",
        // @ts-ignore
        //这里两个用于路由守卫 权限判断使用
        meta: {
          code: "overivew",
          overivew: "@/views/overivew/overivew.vue",
        },
        name: "overivew",
        component: () => import("@/views/overivew/overivew.vue"),
      },
      {
        path: "/resize",
        meta: {
          code: "resize",
        },
        component: () => import("@/views/demo/resize-table-header-demo.vue"),
      },
      {
        path: "/inquiries",
        name: "inquiries",
        meta: {
          code: "ask-tool:project-page",
          menu: "inquiries",
          search: true,
          bread: [
            {
              label: "询量",
              name: "inquiries",
            },
          ],
        },
        component: () => import("@/views/inquiries/inquirie_new.vue"), //新路由
        // component: () => import("@/views/inquiries/inquiries.vue"),//老路由
      },
      {
        path: "/programList",
        name: "programList",
        meta: {
          code: "ask-tool:program-list",
          menu: "programList",
          search: true,
          bread: [
            {
              label: "节目单",
              name: "programList",
            },
          ],
        },
        component: () => import("@/views/inquiries/program.vue"), //新路由
        // component: () => import("@/views/inquiries/inquiries.vue"),//老路由
      },
      {
        path: "/schedulingList",
        name: "schedulingList",
        meta: {
          code: "scheduling_calculation:page",
          menu: "schedulingList",
          search: true,
          bread: [
            {
              label: "排期计算",
              name: "schedulingList",
            },
          ],
        },
        component: () => import("@/views/auxiliary_tools/schedule_calculation.vue"),
      },
      {
        path: "/add_schedulingInfo",
        name: "addSchedulingLInfo",
        meta: {
          menu: "schedulingList",
          back: true,
          code: ["scheduling_calculation:save", "scheduling_calculation:update"],
          backName: "schedulingList",
          bread: [
            {
              label: "排期计算",
              // 点击面包屑第一项应返回排期计算列表页
              name: "schedulingList",
            },
          ],
          title: "排期计算",
        },
        component: () => import("@/views/auxiliary_tools/add_scheduing_information.vue"),
      },
      {
        path: "/add_schedulingList",
        name: "addSchedulingList",
        meta: {
          menu: "schedulingList",
          back: true,
          code: ["scheduling_calculation:save", "scheduling_calculation:update"],
          backName: "addSchedulingLInfo",
          bread: [
            {
              label: "排期计算",
              name: "addSchedulingList",
            },
          ],
          title: "排期计算",
        },
        component: () => import("@/views/auxiliary_tools/add_schedule_calculation.vue"),
      },
      {
        path: "/settlementProcess",
        name: "settlementProcess",
        meta: {
          code: "settlement_process:page",
          menu: "settlementProcess",
          search: true,
          bread: [
            {
              label: "结算证明",
              name: "settlementProcess",
            },
          ],
        },
        component: () => import("@/views/order_data/settlement_process.vue"),
      },
      {
        path: "/orderData",
        name: "orderData",
        meta: {
          code: "ask-tool:proof",
          menu: "orderData",
          search: true,
          bread: [
            {
              label: "流量证明",
              name: "orderData",
            },
          ],
        },
        component: () => import("@/views/order_data/order_data_list.vue"),
      },
      {
        path: "/inquiries/addInquiries",
        name: "addInquiries",
        meta: {
          menu: "inquiries",
          code: [
            "ask-tool:project-add",
            "ask-tool:project-update",
            "ask-tool:task-add",
            "ask-tool:task-detail",
            "ask-tool:task-update",
            "ask-tool:task-copy",
            "ask-tool:task-download",
          ],
          backName: "inquiries",
          back: true,
          bread: [
            {
              label: "询量",
              name: "inquiries",
            },
            // 第二个面包屑文案在页面中根据“新建 / 编辑 / 复制”动态覆盖
            {
              label: "新建",
              name: "addInquiries",
            }
          ],
          title: "新建询量",
        },
        component: () => import("@/views/inquiries/addInquiries.vue"),
      },
      {
        path: "/polling",
        name: "polling",
        meta: {
          code: "ask:page",
          menu: "polling",
          bread: [
            {
              label: "询量",
              name: "polling",
            },
          ],
        },
        component: () => import("@/views/polling/polling.vue"),
      },
      {
        path: "/polling/addOrderPolling",
        name: "addOrderPolling",
        meta: {
          menu: "polling",
          back: true,
          code: ["ask:add", "ask:update", "ask:copy", "ask:addVersion"],
          backName: "polling",
          bread: [
            {
              label: "询量",
              name: "polling",
            },
            {
              label: "新建询量",
              name: "addOrderPolling",
            },
          ],
          title: "新建询量",
        },
        component: () => import("@/views/polling/addOrderPolling.vue"),
      },
      {
        path: "/project",
        name: "project",
        meta: {
          code: "subject:page",
          menu: "project",
          bread: [
            {
              label: "项目",
              name: "project",
            },
          ],
        },
        component: () => import("@/views/project/project.vue"),
      },
      {
        path: "/project/addProject",
        name: "addProject",
        meta: {
          menu: "project",
          back: true,
          code: ["subject:save", "subject:update", "subject:info"],
          backName: "project",
          bread: [
            {
              label: "项目",
              name: "project",
            },
            {
              label: "新建项目",
              name: "addProject",
            },
          ],
          title: "新建项目",
        },
        component: () => import("@/views/project/addProject.vue"),
      },
      {
        path: "/project/MarketingServer",
        name: "MarketingServer",
        meta: {
          menu: "project",
          back: true,
          code: ["subject:sell", "subject:voucherInfo"],
          backName: "project",
          bread: [
            {
              label: "项目",
              name: "project",
            },
            {
              label: "项目名称",
              name: "project",
            },
            {
              label: "营销服务配置",
              name: "MarketingServer",
            },
          ],
          title: "营销服务",
        },
        component: () =>
          import("@/views/project/components/MarketingServer.vue"),
      },
      {
        path: "/project/projectChangeTake",
        name: "projectChangeTake",
        meta: {
          menu: "project",
          back: true,
          code: ["subject:updateLog"],
          backName: "project",
          query: {
            id: "projectId", //key 指代这个页面需要的参数名，projectId指代上一页的query参数
            name: "name",
          },
          bread: [
            {
              label: "项目",
              name: "project",
            },
            {
              label: "项目名称",
              name: "project",
            },
            {
              label: "修改记录",
              name: "projectChangeTake",
            },
          ],
          title: "修改记录",
        },
        component: () => import("@/views/project/projectChangeTake.vue"),
      },
      {
        path: "/project/projectChangeTakeInfo",
        name: "projectChangeTakeInfo",
        meta: {
          menu: "project",
          back: true,
          code: ["subject:updateLog"],
          backName: "projectChangeTake",
          bread: [
            {
              label: "项目",
              name: "project",
            },
            {
              label: "改单记录",
              name: "projectChangeTake",
            },
            {
              label: "改单记录详情",
            },
          ],
          title: "修改记录",
        },
        component: () => import("@/views/project/projectChangeTakeInfo.vue"),
      },
      // 3.2新建
      {
        path: "/scene/commonTask",
        name: "commonTask",
        meta: {
          menu: "commonTask",
          back: false,
          code: 'auto-screen-project:page',
          backName: "autoscreen",
          bread: [
            {
              label: "项目录屏",
              name: "commonTask",
            },
          ],
          title: "项目录屏",
        },
        component: () => import("@/views/screen/screenTask.vue"),
      },
      {
        path: "/scene/previewTask",
        name: "previewTask",
        meta: {
          menu: "previewTask",
          back: false,
          code: 'auto-screen-preview-task:page',
          backName: "autoscreen",
          bread: [
            {
              label: "投前预览",
              name: "previewTask",
            },
          ],
          title: "投前预览",
        },
        component: () => import("@/views/screen/screenPreviewTask.vue"),
      },
      {
        path: "/scene/sceneParameterConfiguration",
        name: "sceneParameterConfiguration",
        meta: {
          menu: "sceneParameterConfiguration",
          back: false,
          code: 'autoscreen-parameterconfig:page',
          backName: "autoscreen",
          bread: [
            {
              label: "场景参数配置",
              name: "sceneParameterConfiguration",
            },
          ],
          title: "场景参数配置",
        },
        component: () => import("@/views/screen/sceneParameterConfiguration.vue"),
      },
      {
        path: "/scene/advertiserConfiguration",
        name: "advertiserConfiguration",
        meta: {
          menu: "advertiserConfiguration",
          back: false,
          code: 'autoscreen-advertiserconfig:page',
          backName: "autoscreen",
          bread: [
            {
              label: "广告主配置",
              name: "advertiserConfiguration",
            },
          ],
          title: "广告主配置",
        },
        component: () => import("@/views/screen/advertiserConfiguration.vue"),
      },
      {
        path: "/scene/mediaResourceLibrary",
        name: "mediaResourceLibrary",
        meta: {
          menu: "mediaResourceLibrary",
          back: false,
          code: 'autoscreen-mediaresource:page',
          backName: "autoscreen",
          bread: [
            {
              label: "媒体资源库",
              name: "mediaResourceLibrary",
            },
          ],
          title: "媒体资源库",
        },
        component: () => import("@/views/screen/mediaResourceLibrary.vue"),
      },
      {
        path: "/scene/desktopConfig",
        name: "desktopConfig",
        meta: {
          menu: "desktopConfig",
          back: false,
          code: 'desktop-config:page',
          backName: "autoscreen",
          bread: [
            {
              label: "桌面配置",
              name: "desktopConfig",
            },
          ],
          title: "桌面配置",
        },
        component: () => import("@/views/desktop/desktopConfig.vue"),
      },
      {
        path: "/scene/nativeDesktop",
        name: "nativeDesktop",
        meta: {
          menu: "nativeDesktop",
          back: true,
          code: 'desktop-simulation:page',
          backName: "desktopConfig",
          bread: [
            {
              label: "桌面配置",
              name: "desktopConfig",
            },
            {
              label: "模拟桌面",
              name: "nativeDesktop",
            },
          ],
          title: "模拟桌面",
        },
        component: () => import("@/views/desktop/nativeDesktop.vue"),
      },
      // {
      //   path: "/scene/screenRecordingRequirementsConfiguration",
      //   name: "screenRecordingRequirementsConfiguration",
      //   meta: {
      //     menu: "screenRecordingRequirementsConfiguration",
      //     back: false,
      //     code: 'autoscreen-requireconfig:page',
      //     backName: "autoscreen",
      //     bread: [
      //       {
      //         label: "录屏要求配置",
      //         name: "screenRecordingRequirementsConfiguration",
      //       },
      //     ],
      //     title: "录屏要求配置",
      //   },
      //   component: () => import("@/views/screen/screenRecordingRequirementsConfiguration.vue"),
      // },
      {
        path: "/screen/addPreviewOrUpdate",
        name: "addPreviewOrUpdate",
        meta: {
          menu: "previewTask",
          code: [
            "auto-screen-preview-task:save",
            "auto-screen-preview-task:update",
            "auto-screen-preview-task:copy",
          ], //两者有其一 即可进入
          back: false,
          backName: "previewTask",
          bread: [
            {
              label: "投前预览",
              name: "previewTask",
            },
            {
              label: "新建",
              name: "addPreviewOrUpdate",
            },
          ],
          title: "新建",
        },
        component: () => import("@/views/screen/addPreviewOrUpdate.vue"),
      },
      // 旧录屏列表
      // {
      //   path: "/screen",
      //   name: "screen",
      //   meta: {
      //     code: "record-screen:page",
      //     menu: "screen",
      //     bread: [
      //       {
      //         label: "录屏",
      //         name: "screen",
      //       },
      //     ],
      //   },
      //   component: () => import("@/views/screen/screen.vue"),
      // },
      // 新录屏任务列表
      {
        path: "/screen_new",
        name: "screen_new",
        meta: {
          code: "auto-screen-project:page",
          menu: "commonTask",
          back: false,
          bread: [
            {
              label: "项目录屏",
              name: "commonTask",
            },
          ],
          title: "录屏任务列表",
        },
        component: () => import("@/views/screen/screen_new.vue"),
      },
      {
        path: "/screen_task_all",
        name: "screen_task_all",
        meta: {
          code: "auto-screen-project:page",
          menu: "commonTask",
          back: false,
          bread: [
            {
              label: "项目录屏",
              name: "commonTask",
            },
          ],
          title: "录屏任务列表",
        },
        component: () => import("@/views/screen/screen_task_all.vue"),
      },
      {
        path: "/download_center",
        name: "download_center",
        meta: {
          code: "",
          menu: "commonTask",
          back: false,
          bread: [
            {
              label: "下载中心",
              name: "download_center",
            },
          ],
          title: "下载中心",
        },
        component: () => import("@/views/screen/downloadCenter.vue"),
      },
      {
        path: "/screen/addOrUpdate",
        name: "screenAddOrUpdate",
        meta: {
          menu: "commonTask",
          code: [
            "auto-screen:save",
            "auto-screen:task-update",
            "auto-screen:task-copy",
          ], //两者有其一 即可进入
          back: true,
          backName: "commonTask",
          bread: [
            {
              label: "项目录屏",
              name: "commonTask",
            },
            {
              label: "新建",
              name: "screenAddOrUpdate",
            },
          ],
          title: "新建",
        },
        component: () => import("@/views/screen/addOrUpdate.vue"),
      },
      {
        path: "/projectReport",
        name: "projectReport",
        meta: {
          code: "project-report:page",
          menu: "projectReport",
          search: true,
          bread: [
            {
              label: "项目报表",
              name: "programList",
            },
          ],
        },
        component: () => import("@/views/report/projectReport.vue"),
      },
      {
        path: "/largeMarket",
        name: "largeMarket",
        meta: {
          code: "dashboard-report:export-page",
          menu: "largeMarket",
          search: true,
          bread: [
            {
              label: "大盘报表",
              name: "largeMarket",
            },
          ],
        },
        component: () => import("@/views/report/largeMarket.vue"),
      },
      {
        path: "/downProjectReport",
        name: "downProjectReport",
        meta: {
          code: "",
          menu: "projectReport",
          search: true,
          bread: [
            {
              label: "下载报表",
              name: "programList",
            },
          ],
        },
        component: () => import("@/views/report/downloadEmail.vue"),
      },
      {
        path: "/screen/selectOrder",
        name: "screenSelectOrder",
        meta: {
          menu: "commonTask",
          code: [
            "auto-screen:save",
            "auto-screen:task-update",
            "auto-screen:task-copy",
          ], //两者有其一 即可进入
          back: true,
          backName: "commonTask",
          bread: [
            {
              label: "项目录屏",
              name: "screenConfiguration",
            },
            {
              label: "新建",
              name: "selectOrder",
            },
          ],
          title: "新建",
        },
        component: () => import("@/views/screen/selectOrder.vue"),
      },
      {
        path: "/screenTemplate",
        name: "screenTemplate",
        // meta: {
        //   code: "click-template:page",
        //   menu: "screenTemplate",
        //   bread: [
        //     {
        //       label: "录屏模板",
        //       name: "screenTemplate",
        //     },
        //   ],
        // },
        meta: {
          menu: "screenTemplate",
          back: false,
          code: "click-template:page",
          backName: "screenTemplate",
          bread: [
            {
              label: "录屏模板",
              name: "sceneParameterConfiguration",
            },
          ],
          title: "录屏模板",
        },
        component: () => import("@/views/screen/screenTemplate.vue"),
      },
      {
        path: "/screenTemplate/addOrUpdateTemp",
        name: "temPaddOrUpdate",
        meta: {
          menu: "screenTemplate",
          back: true,
          code: [
            "record-screen:save",
            "record-screen:update",
            "click-template:info",
          ],
          backName: "screenTemplate",
          bread: [
            {
              label: "录屏模板",
              name: "screen",
            },
            {
              label: "新建录屏",
              name: "temPaddOrUpdate",
            },
          ],
          title: "新建模板",
        },
        component: () => import("@/views/screen/addOrUpdateTemp.vue"),
      },
      {
        path: "/sys/user",
        name: "user",
        meta: {
          code: "user:page",
          menu: "user",
          bread: [
            {
              label: "账户",
              name: "user",
            },
          ],
        },
        component: () => import("@/views/sys/user/user.vue"),
      },
      {
        path: "/sys/user/addUser",
        name: "addUser",
        meta: {
          menu: "user",
          back: true,
          code: ["user:save", "user:update", "user:info"],
          backName: "user",
          bread: [
            {
              label: "账户",
              name: "user",
            },
            {
              label: "新建账户",
              name: "addUser",
            },
          ],
          title: "新建账户",
        },
        component: () => import("@/views/sys/user/addUser.vue"),
      },
      {
        path: "/sys/role",
        name: "role",
        meta: {
          code: "role:page",
          menu: "role",
          bread: [
            {
              label: "角色",
              name: "role",
            },
          ],
        },
        component: () => import("@/views/sys/role/role.vue"),
      },
      {
        path: "/sys/role/addRole",
        name: "addRole",
        meta: {
          menu: "role",
          back: true,
          code: ["role:save", "role:update", "role:info"],
          backName: "role",
          bread: [
            {
              label: "角色",
              name: "role",
            },
            {
              label: "新建角色",
              name: "addRole",
            },
          ],
          title: "新建角色",
        },
        component: () => import("@/views/sys/role/addRole.vue"),
      },
      {
        path: "/demo/tree",
        name: "tree",
        meta: {
          menu: "role",
          back: true,
          code: ["role:save", "role:update"],
          backName: "role",
          bread: [
            {
              label: "角色",
              name: "role",
            },
            {
              label: "新建角色",
              name: "addRole",
            },
          ],
        },
        component: () => import("@/views/demo/tree.vue"),
      },
      {
        path: "/demo/treeThree",
        name: "tree",
        meta: {
          menu: "role",
          back: true,
          code: ["role:save", "role:update"],
          backName: "role",
          bread: [
            {
              label: "角色",
              name: "role",
            },
            {
              label: "新建角色",
              name: "addRole",
            },
          ],
        },
        component: () => import("@/views/demo/treeThree.vue"),
      },
      {
        path: "/order",
        name: "order",
        meta: {
          code: "order:page",
          menu: "order",
          bread: [
            {
              label: "订单",
              name: "order",
            },
          ],
        },
        component: () => import("@/views/order/order.vue"),
      },
      {
        path: "/order/addOrUpdateOrder",
        name: "addOrUpdateOrder",
        meta: {
          menu: "order",
          back: true,
          code: ["order:save", "order:update", "order:info"],
          backName: "order",
          bread: [
            {
              label: "订单",
              name: "order",
            },
            {
              label: "新建订单",
              name: "addOrUpdateOrder",
            },
          ],
          title: "新建订单",
        },
        component: () => import("@/views/order/addOrUpdateOrder.vue"),
      },
      {
        path: "/orderTake",
        name: "orderTake",
        meta: {
          code: "order:updateLog",
          menu: "order",
          back: true,
          backName: "order",
          query: {
            id: "pid", //key 指代这个页面需要的参数名，pid指代上一页的query参数
            name: "name",
          },
          bread: [
            {
              label: "订单",
              name: "order",
            },
            {
              label: "新建订单",
              name: "order",
            },
            {
              label: "改单记录",
            },
          ],
          title: "改单记录",
        },
        component: () => import("@/views/order/orderChangeTake.vue"),
      },
      {
        path: "/orderTake/orderTakeInfo",
        name: "orderTakeInfo",
        meta: {
          menu: "order",
          back: true,
          backName: "orderTake",
          code: ["order:save", "order:update", "order:info"],
          bread: [
            {
              label: "订单",
              name: "order",
            },
            {
              label: "新建订单",
              name: "orderTake",
            },
            {
              label: "改单记录",
            },
          ],
        },
        component: () => import("@/views/order/orderChangeTakeInfo.vue"),
      },
      {
        path: "/sys/orderCompany",
        name: "orderCompany",
        meta: {
          code: "order-company:page",
          menu: "orderCompany",
          bread: [
            {
              label: "下单公司",
              name: "orderCompany",
            },
          ],
        },
        component: () => import("@/views/sys/orderCompany/orderCompany.vue"),
      },
      {
        path: "/sys/orderCompany/addOrderCompany",
        name: "addOrderCompany",
        meta: {
          menu: "orderCompany",
          back: true,
          backName: "orderCompany",
          code: ["order-company:upsert"],
          bread: [
            {
              label: "下单公司",
              name: "orderCompany",
            },
            {
              label: "新建公司",
              name: "addOrderCompany",
            },
          ],
          title: "新建公司",
        },
        component: () => import("@/views/sys/orderCompany/addOrderCompany.vue"),
      },
      {
        path: "/sys/advertisers",
        name: "advertisers",
        meta: {
          code: "advertiserManage:list",
          menu: "advertisers",
          bread: [
            {
              label: "广告主管理",
              name: "advertisers",
            },
          ],
        },
        component: () => import("@/views/sys/advertisers/advertisers.vue"),
      },

      {
        path: "/sys/industryManage",
        name: "industryManage",
        meta: {
          back: true,
          backName: "advertisers",
          code: "advertiser:page",
          menu: "advertisers",
          bread: [
            {
              label: "广告主管理",
              name: "advertisers",
            },
            {
              label: "行业管理",
              name: "industryManage",
            },
          ],
        },
        component: () =>
          import("@/views/sys/industryManage/industryManage.vue"),
      },
      {
        path: "/sys/brand",
        name: "brand",
        meta: {
          menu: "advertisers",
          back: true,
          backName: "advertisers",
          code: "advertiser:page",
          bread: [
            {
              label: "广告主管理",
              name: "advertisers",
            },
            {
              label: "品牌管理",
              name: "brand",
            },
          ],
        },
        component: () => import("@/views/sys/brand/brand.vue"),
      },
      {
        path: "/sys/agentCompany",
        name: "agentCompany",
        meta: {
          code: "company:list",
          menu: "agentCompany",
          bread: [
            {
              label: "代理公司",
              name: "agentCompany",
            },
          ],
        },
        component: () => import("@/views/sys/agentCompany/agentCompany.vue"),
      },
      {
        path: "/sys/advertisersManage",
        name: "advertisersManage",
        meta: {
          code: "advertiser:page",
          menu: "advertisersManage",
          bread: [
            {
              label: "广告主",
              name: "agentCompany",
            },
          ],
        },
        component: () =>
          import("@/views/sys/advertisersManage/advertisersManage.vue"),
      },
      {
        path: "/desktop-plan",
        name: "desktopPlan",
        meta: {
          code: "desktop-simulation:page",
          menu: "desktopConfig",
          search: true,
          bread: [
            {
              label: "桌面方案",
              name: "desktopPlan",
            },
          ],
        },
        component: () => import("@/views/desktop/desktop-plan/list.vue"),
      },
      {
        path: "/desktop-plan/form",
        name: "desktopPlanForm",
        meta: {
          menu: "desktopConfig",
          back: true,
          code: ["desktop-plan:save", "desktop-plan:update", "desktop-plan:copy"],
          backName: "desktopConfig",
          bread: [
            {
              label: "桌面方案",
              name: "desktopPlan",
            },
            {
              label: "编辑方案",
              name: "desktopPlanForm",
            },
          ],
          title: "编辑方案",
        },
        component: () => import("@/views/desktop/desktop-plan/list.vue"),
      },
      {
        path: "/demo",
        name: "demo",
        meta: {
          code: "ad-demo:page",
          overivew: "@/views/demo/demo.vue",
          bread: [
            {
              label: "广告Demo",
              name: "demo",
            },
            {
              label: "",
              name: "demo",
            },
          ],
        },
        component: () => import("@/views/demo/demo.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/login.vue"),
  },
];

/**
 * 根据当前用户code 返回出第一个可以跳转的页面，3.5版本
 */
const getUserPermissNextPath = () => {
  let { getPower } = useStore();

  const nextPage: any = (routers as any)[0].children.find((page: { meta: { code: string; }; }) => {
    let code: any = page.meta?.code || "";
    // if (typeof code == "string" && code.includes("page")) {
    //   return getPower(code);
    // }
    // 获取第一个url
    if (typeof code === "string" &&
      (code.includes("page") ||
        code.includes("list") ||
        code.includes("proof"))) {
      return getPower(code);
    }
  });
  // console.error(nextPage, '第一个url', routers)
  return nextPage == undefined ? "/permissions" : nextPage.path;
};

export { routers, getUserPermissNextPath };
